import { type FC } from 'react';
import AppCard from './AppCard';
import { UiIconHandshake } from '@/lib/ui';

export interface SponsorExhibitorCardProps {
  isSelected?: boolean
  navLink?: string
  isEnabled?: boolean
}

const SponsorExhibitorCard: FC<SponsorExhibitorCardProps> = ({
  isSelected = false,
  navLink = '',
  isEnabled = false
}) => {
  return (
    <AppCard
      icon={(<UiIconHandshake size={'3xl'} color={isEnabled ? 'green.500' : 'gray.800'} />)}
      name={'Sponsors & exhibitors'}
      description={'Manage sponsors and exhibitors'}
      isSelected={isSelected}
      navLink={navLink}
    />
  );
};
export default SponsorExhibitorCard;
